import { BetterPageInfoModel } from '../../../shared/data/models/better-page-info.model';
import { LightUserStateModel } from './light-user-state.model';

export interface UserConnectionsModel {
  connections: LightUserStateModel[];
  pageInfo: BetterPageInfoModel;
  loading: boolean;
  error: string;
}

export const initialUserConnection: UserConnectionsModel = {
  connections: [],
  pageInfo: null,
  error: '',
  loading: false
};
